module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EquityCustomizeView.js"));
	}, "EquityCustomizeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityCustomizeView!./src/pages/Promote/Equity/EquityCustomize/EquityCustomizeView.js
// module id = 1137
// module chunks = 431